const MODULE = document.querySelectorAll('[data-module="faq_section"]');

class FaqSection {
    constructor() {
        MODULE.forEach((component) => this.bindItems(component));
    }

    bindItems(component) {
        if (component.dataset.faqInitialized) {
            return;
        }

        component.dataset.faqInitialized = 'true';

        component.querySelectorAll('[data-faq-item]').forEach((item) => {
            const trigger = item.querySelector('[data-faq-trigger]');
            const panel = item.querySelector('[data-faq-panel]');

            if (!trigger || !panel || trigger.disabled) {
                return;
            }

            trigger.addEventListener('click', () => {
                const isOpen = trigger.getAttribute('aria-expanded') !== 'true';

                if (!isOpen && panel.contains(document.activeElement)) {
                    trigger.focus();
                }

                trigger.setAttribute('aria-expanded', String(isOpen));
                item.dataset.open = String(isOpen);
                panel.inert = !isOpen;
                panel.setAttribute('aria-hidden', String(!isOpen));
            });
        });
    }
}

if (MODULE.length) {
    new FaqSection();
}

export default FaqSection;
